import type { AttendanceRecord } from '../types/models';

export const ATTENDANCE_STORAGE_KEY = 'satsuki-attendance-cache';
export const ATTENDANCE_EVENT_NAME = 'satsuki-attendance-updated';

export type AttendanceBroadcastContext = 'punch-in' | 'punch-out' | 'resume';

export interface AttendanceBroadcastDetail {
  record: AttendanceRecord & { id: string };
  context: AttendanceBroadcastContext;
  timestamp: string;
}
